<template>
  <div class="main">
    <a-card :bordered="false" class="cate-lists">
      <div class="main-table">
        <div style="margin-bottom:10px">
          <a-button type="primary" @click="showModal('add')"
            >新增用户组</a-button
          >
        </div>
        <a-table
          :columns="columns"
          :dataSource="rolelist"
          :pagination="false"
          :rowKey="record => record.id"
          :loading="loading"
        >
          <template slot="operation" slot-scope="text, record">
            <a class="active" @click="showModal('edit', record)">编辑</a>
            <a-popconfirm
              title="确认删除么"
              okText="确定"
              cancelText="取消"
              @confirm="del(record)"
            >
              <a class="active">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </div>
    </a-card>
    <a-modal
      title="用户组"
      :visible="visible"
      @ok="modifyExpert"
      okText="提交"
      :maskClosable="false"
      :width="600"
      @cancel="handleCancel"
      destroyOnClose
    >
      <a-form :form="form" @submit="modifyExpert" class="modify-form">
        <a-form-item
          label="编号"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          class="form-project"
          v-show="false"
        >
          <a-input :max-length="20" v-decorator="['id']" disabled />
        </a-form-item>
        <a-form-item
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          label="组名称"
          class="form-project"
        >
          <a-input
            :max-length="20"
            v-decorator="[
              'rolename',
              {
                rules: [
                  { required: true, message: '组名称必填', whitespace: true }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          label="权限说明"
          class="form-project"
        >
          <a-textarea
            :max-length="120"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            v-decorator="[
              'description',
              {
                rules: [
                  { required: true, message: '权限说明必填', whitespace: true }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          label="审核优先级"
          class="form-project"
        >
          <a-input-number
            :max-length="120"
            :min="3"
            :max="100"
            v-decorator="[
              'type',
              {
                rules: [
                  {
                    required: true,
                    message: '审核优先级必填'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 150,
    scopedSlots: { customRender: 'id' },
    align: 'center'
  },
  {
    title: '组名称',
    dataIndex: 'rolename',
    scopedSlots: { customRender: 'rolename' },
    width: 200,
    align: 'center'
  },

  {
    title: '组权限',
    dataIndex: 'description',
    scopedSlots: { customRender: 'description' },
    align: 'center'
  },
  {
    title: '审核优先级',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
];
export default {
  data() {
    return {
      rolelist: [],
      columns,
      loading: true,
      visible: false,
      form: this.$form.createForm(this),
      info: ''
    };
  },
  computed: {},
  watch: {},
  methods: {
    getRolelist() {
      //获取用户组
      this.rolelist = [];
      this.$http
        .post('/api/ucenter/rolelist', { page: 1, limit: 999 })
        .then(res => {
          if (res.data.state == 200) {
            res.data.data.forEach(item => {
              if (item.type > 0) {
                this.rolelist.push(item);
              }
            });

            this.loading = false;
          }
        });
    },
    showModal(type, record) {
      this.visible = true;
      if (type === 'edit') {
        this.info = record.config.catalist;
        this.$nextTick(function() {
          this.form.setFieldsValue({
            id: record.id,
            description: record.description,
            rolename: record.rolename,
            type: record.type
          });
        });
      } else if (type === 'add') {
        this.info = '';
        this.$nextTick(function() {
          this.form.setFieldsValue({
            id: 0,
            type: 10
          });
        });
      }
    },
    handleCancel() {
      this.visible = false;
    },
    modifyExpert(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let param = {
            id: values.id == 0 ? '' : values.id,
            rolename: values.rolename,
            description: values.description,
            type: values.type,
            catalist: this.info
          };
          this.$http.post('/api/ucenter/roleupdate', param).then(res => {
            if (res.data.state == 200) {
              this.$message.success('操作成功');
              this.loading = true;
              this.visible = false;
              this.getRolelist();
            } else {
              this.$message.error('操作失败');
            }
          });
        }
      });
    },
    del(record) {
      if (record.type === '100') {
        this.$message.warn('无法删除优先级为100的用户组');
        return false;
      }
      this.$http
        .post('/api/ucenter/roledel', {
          ids: record.id
        })
        .then(res => {
          if (res.data.state == 200) {
            this.$message.success('操作成功');
            this.loading = true;
            this.getRolelist();
          } else {
            this.$message.error('操作失败');
          }
        });
    }
  },
  mounted() {
    this.getRolelist();
  }
};
</script>
<style scoped>
.main-table {
  padding: 10px;
}
.active {
  margin-right: 5px;
  color: #40a9ff;
}
.modify-form {
  display: flex;
  flex-wrap: wrap;
}
.form-project {
  width: 100%;
}
</style>
